import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

/**
 * تحويل عدة عناصر HTML إلى PDF متعدد الصفحات
 */
const renderMultiPagePDF = async (
  htmlElements: { element: HTMLElement; isNewPage?: boolean }[],
  fileName: string
): Promise<boolean> => {
  try {
    console.log('🔄 بدء عملية إنشاء PDF متعدد الصفحات...');
    
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = 210; // A4 width in mm
    const pageHeight = 297; // A4 height in mm
    let isFirstPage = true;

    for (const { element, isNewPage = false } of htmlElements) {
      // إضافة صفحة جديدة إذا لزم الأمر
      if (!isFirstPage || isNewPage) {
        pdf.addPage();
      }
      isFirstPage = false;

      // تحويل العنصر إلى canvas
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        allowTaint: false,
        backgroundColor: '#ffffff',
        width: element.scrollWidth,
        height: element.scrollHeight,
      });

      // حساب الأبعاد
      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // إضافة الصورة إلى PDF
      const imgData = canvas.toDataURL('image/png', 0.8);
      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
    }

    // تنزيل الملف
    pdf.save(fileName);
    
    console.log('✅ تم إنشاء PDF متعدد الصفحات بنجاح');
    return true;
    
  } catch (error) {
    console.error('❌ خطأ في إنشاء PDF متعدد الصفحات:', error);
    throw error;
  }
};

/**
 * تحويل HTML إلى PDF بصفحات منفصلة
 */
export const renderSeparatePagesPDF = async (
  htmlPages: string[],
  fileName: string
): Promise<boolean> => {
  try {
    console.log('🔄 بدء عملية إنشاء PDF بصفحات منفصلة...');
    
    // إنشاء container مؤقت
    const tempContainer = document.createElement('div');
    tempContainer.style.position = 'absolute';
    tempContainer.style.left = '-9999px';
    tempContainer.style.top = '-9999px';
    tempContainer.style.width = '210mm';
    tempContainer.style.background = 'white';
    document.body.appendChild(tempContainer);

    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = 210;
    let isFirstPage = true;

    for (const htmlContent of htmlPages) {
      // إضافة صفحة جديدة
      if (!isFirstPage) {
        pdf.addPage();
      }
      isFirstPage = false;

      // إضافة المحتوى للـ container
      tempContainer.innerHTML = htmlContent;

      // انتظار تحميل المحتوى
      await new Promise(resolve => setTimeout(resolve, 500));

      // تحويل إلى canvas
      const canvas = await html2canvas(tempContainer, {
        scale: 2,
        useCORS: true,
        allowTaint: false,
        backgroundColor: '#ffffff',
        onclone: (clonedDoc) => {
          // إضافة أنماط مخصصة للتأكد من التطبيق الصحيح للخط العربي
          const style = clonedDoc.createElement('style');
          style.textContent = `
            * {
              font-family: 'Tajawal', 'Arial', sans-serif !important;
              direction: rtl !important;
            }
            body {
              font-family: 'Tajawal', 'Arial', sans-serif !important;
              direction: rtl !important;
            }
          `;
          clonedDoc.head.appendChild(style);
        }
      });

      // حساب الأبعاد
      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // إضافة الصورة إلى PDF
      const imgData = canvas.toDataURL('image/png', 0.8);
      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
    }

    // تنظيف
    document.body.removeChild(tempContainer);

    // تنزيل الملف
    pdf.save(fileName);
    
    console.log('✅ تم إنشاء PDF بصفحات منفصلة بنجاح');
    return true;
    
  } catch (error) {
    console.error('❌ خطأ في إنشاء PDF بصفحات منفصلة:', error);
    
    // تنظيف في حالة الخطأ
    const tempContainer = document.querySelector('div[style*="-9999px"]');
    if (tempContainer) {
      document.body.removeChild(tempContainer);
    }
    
    throw error;
  }
};